﻿import { useEffect, useState } from 'react';

interface ITextToSpeechProps {
	text: string;
	volume?: number;
	rate?: number;
	pitch?: number;
}

export function useTextToSpeech({ text, rate, pitch, volume }: ITextToSpeechProps) {
	const [utterance, setUtterance] = useState<SpeechSynthesisUtterance | null>(null);

	useEffect(() => {
		const synth = window.speechSynthesis;
		const utterance = new SpeechSynthesisUtterance(text);
		utterance.lang = 'en-US';
		utterance.volume = volume ?? 1;
		utterance.rate = rate ?? 1;
		utterance.pitch = pitch ?? 1;
		setUtterance(utterance);

		return () => {
			synth.cancel();
		};
	}, [pitch, rate, text, volume]);

	const listenToText = () => {
		if (!text) {
			return;
		}

		if (utterance) {
			window.speechSynthesis.speak(utterance);
		}
	};

	return {
		listenToText,
	};
}
